export default "__VITE_ASSET__c98a5150__"